/** Сколько узлов дерева с непустым вложенным `fields.items`. */
export function countTreeTableNestedBranches(rows: unknown[] | undefined): number {
  if (!Array.isArray(rows) || rows.length === 0) return 0
  let n = 0
  const itemsRowsOf = (row: unknown): unknown[] | null => {
    if (!row || typeof row !== 'object') return null
    const rec = row as { fields?: { items?: unknown }; items?: unknown }
    const itemsField = rec.fields?.items ?? rec.items
    if (!itemsField || typeof itemsField !== 'object') return null
    const nested =
      (itemsField as { value?: { rows?: unknown[] } }).value?.rows ??
      (itemsField as { rows?: unknown[] }).rows ??
      (Array.isArray(itemsField) ? itemsField : null)
    return Array.isArray(nested) && nested.length > 0 ? nested : null
  }
  const walk = (list: unknown[]) => {
    for (const r of list) {
      const ch = itemsRowsOf(r)
      if (ch) {
        n++
        walk(ch)
      }
    }
  }
  walk(rows)
  return n
}

export type ResolveTreeTableBackingRowsOptions = {
  registryEmptyFlag?: boolean
}

/**
 * Выбор сырого `rows[]` для TreeTable: после lazy expand реестр часто содержит
 * вложенные `items`, а pagesData — ещё плоский снимок с тем же числом корневых строк.
 */
export function resolveTreeTableBackingRows(
  pageRows: unknown[],
  registryRows: unknown[],
  options?: ResolveTreeTableBackingRowsOptions,
): unknown[] {
  if (options?.registryEmptyFlag === true) {
    return Array.isArray(registryRows) ? registryRows : []
  }
  if (options?.registryEmptyFlag === false && Array.isArray(registryRows) && registryRows.length > 0) {
    // 0→1: page ещё empty:true, registry уже с строками.
    if (!Array.isArray(pageRows) || pageRows.length === 0) {
      return registryRows
    }
  }
  if (!Array.isArray(pageRows) || pageRows.length === 0) {
    return Array.isArray(registryRows) ? registryRows : []
  }
  if (!Array.isArray(registryRows) || registryRows.length === 0) {
    return pageRows
  }

  const pageNested = countTreeTableNestedBranches(pageRows)
  const regNested = countTreeTableNestedBranches(registryRows)
  if (regNested !== pageNested) {
    return regNested > pageNested ? registryRows : pageRows
  }

  // При равной «глубине» предпочитаем реестр — он обновляется setValue/refill после expand.
  return registryRows
}
